// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"667":"boclips-player","2983":"vnd-forms","3622":"educator-ratings-rrp","3674":"bxslider","7372":"range-slider"}[chunkId] || chunkId) + "-" + {"667":"01a582de","2983":"d3053219","3622":"5b66ef1f","3674":"d5cd6b85","4027":"cdaa7bb9","7147":"79862f1b","7372":"34566d0b","8776":"e9e4e953"}[chunkId] + ".chunk.css";
};